// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 823 ? "ff1d5d75" : chunkId) + "." + {"823":"2842d30f1586e9d5","914":"9c8b91a41be0e071"}[chunkId] + ".js";
};